import React, { useState, useEffect } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { Col, Row } from 'react-bootstrap'
import { MDBDataTable } from 'mdbreact'
import axios from 'axios'
import {
  AdminMessAttendanceAdd,
  AdminMessAttendanceMemberList,
} from '../../ApiFile'
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
} from '@mui/material'
import { toast } from 'react-toastify'
import Sidebar from '../../AluminiAdminDashboardDesign/sidebar'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import NavLogo from '../../AluminiAdminDashboardDesign/NavLogo'
import { notification } from 'antd'
import MobileNavbarAdmin from '../../AluminiAdminDashboardDesign/pages/MobileNavbarAdmin'

const MessAttendanceAdmin = () => {
  const [studentDataType, setStudentDataType] = useState('')
  const [date, setDate] = useState(dayjs())
  const [attendanceType, setAttendanceType] = useState(1)
  const [memberList, setMemberList] = useState([])
  const [totalStudents, setTotalStudents] = useState(0)
  const [totalPresent, setTotalPresent] = useState(0)
  const [totalAbsent, setTotalAbsent] = useState(0)
  const [selectOption, setSelectOption] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  const handleSelectOptionChange = (event) => {
    setSelectOption(event.target.value)
  }

  const handleStudentDataTypeChange = (event) => {
    setStudentDataType(event.target.value)
  }

  const handleAttendanceTypeChange = (event) => {
    setAttendanceType(event.target.value)
  }

  const updateTotals = (members) => {
    const total = members.length
    const present = members.filter((member) => member.statusflag === '1').length
    const absent = members.filter((member) => member.statusflag === '2').length
    setTotalStudents(total)
    setTotalPresent(present)
    setTotalAbsent(absent)
  }

  const handleAttendanceToggle = (memberId, flag) => {
    setMemberList((prevList) => {
      const updatedList = prevList.map((member) =>
        member.member_id === memberId
          ? { ...member, statusflag: flag }
          : member,
      )
      updateTotals(updatedList)
      return updatedList
    })
  }

  const handleSaveAttendance = () => {
    if (!selectOption) {
      notification.warning({
        message: 'Warning',
        description: 'Please Select Meal.',
      })
      return
    }
    if (!studentDataType) {
      notification.warning({
        message: 'Warning',
        description: 'Please Select Data Type.',
      })
      return
    }

    const hasPendingAttendance = memberList.some(
      (member) => member.statusflag === '0',
    )

    if (hasPendingAttendance) {
      toast.error('Please check all attendance records before saving!')
    } else {
      const attendanceData = {
        flag: attendanceType,
        attendance_date: date.format('DD/MM/YYYY'),
        listflag: selectOption,
        attendanceList: memberList.map((member) => ({
          member_id: member.member_id,
          statusflag: member.statusflag,
        })),
      }
      axios
        .post(AdminMessAttendanceAdd, attendanceData)
        .then((response) => {
          if (response.data === "SAVED") {
            toast.success('Attendance data saved successfully!')
          }
          setSelectOption('')
          setStudentDataType('')
          setMemberList([])
        })
        .catch((error) => {
          console.error('There was an error saving the attendance data!', error)
        })
    }
  }

  const fetchMemberList = (studentDataType) => {
    const formattedDate = date.format('DD/MM/YYYY')
    axios
      .post(AdminMessAttendanceMemberList, {
        list_flag: studentDataType,
        attendance_date: formattedDate,
      })
      .then((response) => {
        const members = response.data.map((member) => ({
          ...member,
          statusflag:
            selectOption === 1
              ? member.lunch_flag.toString()
              : member.dinner_flag.toString(),
        }))
        setMemberList(members)
        updateTotals(members)
      })
      .catch((error) => {
        console.error('Error fetching member list:', error)
      })
  }

  useEffect(() => {
    fetchMemberList(studentDataType)
    setCurrentPage(1) // reset to page 1 when filters change
  }, [studentDataType, date, selectOption])

  const getButtonStyle = (flag, buttonType) => {
    if (flag === '0') return { backgroundColor: 'white', color: 'black' }
    if (flag === '1' && buttonType === 'P')
      return { backgroundColor: 'green', color: 'white' }
    if (flag === '2' && buttonType === 'A')
      return { backgroundColor: 'red', color: 'white' }
    return { backgroundColor: 'white', color: 'black' }
  }

  const paginatedMembers = memberList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  )

  const data = {
    columns: [
      { label: 'Sr.No', field: 'sno', sort: 'asc' },
      { label: 'Block No', field: 'block_id', sort: 'asc' },
      { label: 'Room No', field: 'room_id', sort: 'asc' },
      { label: 'Name', field: 'name', sort: 'asc' },
      { label: 'Attendance', field: 'statusflag', sort: 'asc' },
    ],
    rows: paginatedMembers.map((member, index) => ({
      sno: (currentPage - 1) * itemsPerPage + index + 1,
      ...member,
      name: <span className="text-start">{member.name}</span>,
      statusflag: (
        <>
          <Button
            variant="contained"
            className="me-1"
            style={getButtonStyle(member.statusflag, 'P')}
            onClick={() => handleAttendanceToggle(member.member_id, '1')}
          >
            <b>P</b>
          </Button>
          <Button
            variant="contained"
            className="ms-1"
            style={getButtonStyle(member.statusflag, 'A')}
            onClick={() => handleAttendanceToggle(member.member_id, '2')}
          >
            <b>A</b>
          </Button>
        </>
      ),
    })),
  }

  return (
    <>
          <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <NavLogo />
                  
                        <div className="d-block d-md-none">
                          <MobileNavbarAdmin />
                        </div>
       <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
             Mess Attendance
            </h5>
          </div>

          {/* Filters */}
          <Row className="m-0 pt-1 px-2 px-md-3 rounded">
            <Col
              className="m-0 p-0 px-3 py-3 rounded shadow"
              style={{ background: 'white' }}
            >
              <Row>
                <Col md={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <DatePicker
                        format="DD-MM-YYYY"
                        label="Select Date"
                        className="w-100"
                        value={date}
                        onChange={(newDate) => setDate(newDate)}
                        minDate={dayjs().subtract(1, 'day')} // Set min date to yesterday
                        maxDate={dayjs()} // Disables all future dates (i.e., from tomorrow)
                        slotProps={{ textField: { size: 'small' } }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Col>
                <Col md={3}>
                  <FormControl fullWidth margin="dense" size="small">
                    <InputLabel>Select Meal</InputLabel>
                    <Select
                      value={selectOption}
                      onChange={handleSelectOptionChange}
                      label="Select Meal"
                    >
                      <MenuItem value={1}>Lunch</MenuItem>
                      <MenuItem value={2}>Dinner</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
                <Col md={3}>
                  <FormControl fullWidth margin="dense" size="small">
                    <InputLabel>Student Data Type</InputLabel>
                    <Select
                      value={studentDataType}
                      onChange={handleStudentDataTypeChange}
                      label="Student Data Type"
                    >
                      <MenuItem value={1}>Block Wise</MenuItem>
                      <MenuItem value={2}>Alphabetical Order</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
                <Col md={3}>
                  <FormControl fullWidth margin="dense" size="small">
                    <InputLabel>Attendance Type</InputLabel>
                    <Select
                      value={attendanceType}
                      onChange={handleAttendanceTypeChange}
                      label="Attendance Type"
                    >
                      <MenuItem value={1}>Manual</MenuItem>
                      <MenuItem value={2}>Biometric</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Table */}
          <Row className="m-0 pt-1 px-2 px-md-3 mb-5 rounded">
            <Col
              className="m-0 p-0 px-3 py-3 rounded shadow"
              style={{ background: 'white' }}
            >
              <div style={{ overflowX: 'auto' }}>
                <MDBDataTable
                  striped
                  bordered
                  hover
                  className="custom-datatable text-center"
                  data={data}
                  paging={false}
                  info={false}
                />
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  count={Math.ceil(memberList.length / itemsPerPage)}
                  page={currentPage}
                  onChange={(e, page) => setCurrentPage(page)}
                  color="primary"
                />
              </div>

              {/* Totals */}
              <div
                className="text-center pt-2 mt-3 rounded"
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  border: '1px solid rgb(214, 222, 219)',
                }}
              >
                <p>
                  <b style={{ color: 'maroon' }}>Total Students</b>:{' '}
                  <b>{totalStudents}</b>
                </p>
                <p>
                  <b style={{ color: 'green' }}>Total Present</b>:{' '}
                  <b>{totalPresent}</b>
                </p>
                <p>
                  <b style={{ color: 'red' }}>Total Absent</b>:{' '}
                  <b>{totalAbsent}</b>
                </p>
              </div>

              {/* Save Button */}
              <div className="text-center mt-3 mb-4">
                <Button
                  style={{ backgroundColor: 'rgb(0, 120, 215)' }}
                  onClick={handleSaveAttendance}
                >
                  <b style={{ color: 'white' }}>Save Attendance</b>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      </div>
    </>
  )
}

export default MessAttendanceAdmin
